import { useLocation, Link } from "react-router-dom";

export default function NavSlot({ navItems }) {
  const location = useLocation();
  const currentPath = location.pathname;

  function isActiveLink(targetPath, exact = false) {
    const normalizedPath = targetPath?.replace(/\/$/, "");
    return exact
      ? currentPath === normalizedPath
      : currentPath === normalizedPath ||
          currentPath.startsWith(normalizedPath + "/");
  }

  return (
    <div className="lg:px-3 px-4 flex overflow-x-auto border-b ">
      {navItems.map((item) => {
        const isActive = isActiveLink(item.path, item.matchExact);
        return (
          <Link
            key={item.path}
            to={item.path}
            className={`text-sm  h-full ${
              isActive
                ? "border-b-2 border-primary text-foreground"
                : "text-muted-foreground"
            } flex-shrink-0`}
          >
            <span className="md:px-3 px-2.5 py-2 block rounded-md hover:bg-muted">
              {item.label}
            </span>
          </Link>
        );
      })}
    </div>
  );
}
